











































































import Vue from 'vue';
import { SelectableAmount } from '@/interfaces/payment/selectableAmount';
import OptionLabel from '../OptionLabel.vue';
import ValidationMixin from '@/mixins/validationMixin';
import LabelMixin from '@/mixins/labelMixin';

export default Vue.extend({
  components: { OptionLabel },
  mixins: [ValidationMixin, LabelMixin],
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    selectableAmounts: {
      type: Array as () => Array<SelectableAmount>,
      default: () => [],
    },
    max: {
      type: Number,
      default: null,
    },
    min: {
      type: Number,
      default: null,
    },
    adminFee: {
      type: Number,
      default: null,
    },
    feeRegulationUrl: {
      type: String,
      default: null,
    },
    displayFee: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      customDonationAmount: null,
      donationAmount: this.value,
      hideFee: true,
      errorText: null,
      sortedSelectableAmounts: [] as SelectableAmount[],
    };
  },
  computed: {
    showError(): boolean {
      return !!this.errorText;
    }
  },
  watch: {
    customDonationAmount(value: number | null) {
      if (!!value) {
        let hasValidCustomAmount: boolean = this.validateDonationAmount(value);
        if (!hasValidCustomAmount) {
          this.errorText = hasValidCustomAmount;
        } else {
          this.errorText = null;
          this.donationAmount = value;
        }
      }
    },
    donationAmount(value) {
      this.$emit('input', value);
    },
    adminFee() {
      this.hideFee = !this.adminFee || this.adminFee === 0 || !this.displayFee;
    },
    displayFee() {
      this.hideFee = !this.adminFee || this.adminFee === 0 || !this.displayFee;
    },
    value(newVal) {
      this.donationAmount = newVal;
    },
  },
  mounted() {
    this.hideFee = !this.adminFee || this.adminFee === 0 || !this.displayFee;
    this.sortedSelectableAmounts = this.selectableAmounts.sort(
      (a: SelectableAmount, b: SelectableAmount) => {
        return a.id - b.id;
      }
    );
  },
  methods: {
    selectDonationAmount(selectedAmount: SelectableAmount) {
      this.donationAmount = selectedAmount.amount;
      this.customDonationAmount = null;
    },
    validateDonationAmount(value: any) {
      const donationAmount = parseInt(value);
      const trueDonationAmount = parseFloat(value);
      if (typeof donationAmount !== 'number') {
        return this.$t('validation.numeric');
      } else if (!Number.isInteger(trueDonationAmount)) {
        return this.$t('validation.nonInteger');
      } else if (/^\d+\.\d+$/.test(value)) {
        // if the value is an integer, but of a bad form (e.g. 10.0)
        return this.$t('validation.hasDecimal');
      } else if (!!this.max && this.max < donationAmount) {
        return this.$t('validation.maxValue', { max: this.max });
      } else if (!!this.min && donationAmount < this.min) {
        return this.$t('validation.minValue', { min: this.donationMinAmount });
      }

      return true;
    },
  },
});
